import React from "react";
import { Star, Gamepad2, MapPin, Clock, Users, Timer } from "lucide-react";
import { Reveal } from "./Reveal";
import { BUSINESS } from "../data";

const cards = [
  {
    icon: Star,
    value: BUSINESS.reviews,
    label: "Google Reviews",
    span: "md:col-span-5",
    accent: "text-neon",
    testid: "highlight-reviews",
  },
  {
    icon: Gamepad2,
    value: "Game Store",
    label: "Play & Explore",
    span: "md:col-span-3",
    accent: "text-violet",
    testid: "highlight-category",
  },
  {
    icon: MapPin,
    value: "Jakarta",
    label: "Jakarta Selatan, Indonesia",
    span: "md:col-span-4",
    accent: "text-pink",
    testid: "highlight-location",
  },
  {
    icon: Clock,
    value: `Opens ${BUSINESS.opens}`,
    label: "Daily opening time",
    span: "md:col-span-4",
    accent: "text-neon",
    testid: "highlight-hours",
  },
];

export const Highlights = () => (
  <section
    id="highlights"
    data-testid="highlights-section"
    className="relative py-20 md:py-28 scroll-mt-20"
  >
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="grid grid-cols-1 md:grid-cols-8 gap-5">
        {cards.map((c, i) => (
          <Reveal
            key={c.testid}
            delay={i * 0.08}
            className={`group ${c.span}`}
          >
            <div
              data-testid={c.testid}
              className="glass h-full rounded-3xl p-8 flex flex-col justify-between gap-8 border-white/10 group-hover:border-neon/40 group-hover:-translate-y-1 transition-[transform,border-color] duration-300"
            >
              <c.icon size={28} className={c.accent} strokeWidth={1.5} />
              <div>
                <div className="font-display font-black text-3xl md:text-4xl tracking-tighter text-white">
                  {c.value}
                </div>
                <div className="mt-2 text-sm text-white/50">{c.label}</div>
              </div>
            </div>
          </Reveal>
        ))}

        <Reveal delay={0.32} className="md:col-span-8">
          <div
            data-testid="highlight-note"
            className="glass rounded-3xl p-8 flex flex-col sm:flex-row items-start sm:items-center gap-6 sm:gap-12 border-white/10"
          >
            <div className="flex items-center gap-4">
              <Timer size={26} className="text-violet shrink-0" strokeWidth={1.5} />
              <p className="text-sm md:text-base text-white/70">
                Typically busiest around{" "}
                <span className="text-white font-semibold">{BUSINESS.busy}</span>
              </p>
            </div>
            <div className="hidden sm:block h-8 w-px bg-white/10" />
            <div className="flex items-center gap-4">
              <Users size={26} className="text-pink shrink-0" strokeWidth={1.5} />
              <p className="text-sm md:text-base text-white/70">
                Visitors commonly spend{" "}
                <span className="text-white font-semibold">{BUSINESS.visit}</span>{" "}
                here
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
